export default "__VITE_ASSET__3mshyqVD__"